if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        // Botão
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span') || this.submitButton;

        if (this.submitButtonText) {
          this.submitButtonText.textContent = 'TENHO INTERESSE NESSE PRODUTO';
        }

        // Redireciona o submit para WhatsApp
        this.form.addEventListener('submit', this.redirectToWhatsApp.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Chama personalização visual
        this.applyWhatsAppStyle();
      }

      redirectToWhatsApp(evt) {
        evt.preventDefault();
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.setAttribute('aria-disabled', true);

        // Título do produto
        const titleEl =
          document.querySelector('[data-product-title]') ||
          document.querySelector('.product__title') ||
          document.querySelector('h1') ||
          null;
        const productTitle = (titleEl?.textContent || document.title || 'Produto').trim();

        // URL da página
        const productUrl = window.location.href;

        // Opções selecionadas
        const optionInputs = this.form.querySelectorAll('select[name^="options"], input[name^="options"]');
        const optionPairs = [];
        optionInputs.forEach((el) => {
          const label = (el.closest('fieldset')?.querySelector('legend')?.textContent || el.name || 'Opção').trim();
          const val = (el.value || el.getAttribute('value') || '').trim();
          if (val) optionPairs.push(`${label}: ${val}`);
        });
        const optionsText = optionPairs.join(' | ');

        // Variant ID e SKU
        const variantId = this.variantIdInput?.value || '';
        const skuEl = this.form.querySelector('[name="sku"]') || this.form.querySelector('[data-sku]');
        const sku = (skuEl?.value || skuEl?.getAttribute?.('data-sku') || '').trim();

        const msgLines = [
          `Olá! Tenho interesse no produto: ${productTitle}`,
          productUrl,
          optionsText ? `Opções: ${optionsText}` : '',
          sku ? `SKU: ${sku}` : '',
          variantId ? `ID da variante: ${variantId}` : ''
        ].filter(Boolean);

        const message = encodeURIComponent(msgLines.join('\n'));
        const whatsappNumber = '5537998714067'; // +55 37 99871-4067
        const waUrl = `https://wa.me/${whatsappNumber}?text=${message}`;

        window.open(waUrl, '_blank');

        setTimeout(() => {
          this.submitButton.removeAttribute('aria-disabled');
        }, 500);

        return false;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = 'TENHO INTERESSE NESSE PRODUTO';
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      // ===== ESTILO VISUAL WHATSAPP =====
      applyWhatsAppStyle() {
        if (!this.submitButton) return;

        this.submitButton.classList.add('btn-whatsapp');
        const labelEl = this.submitButton.querySelector('span') || this.submitButton;

        labelEl.innerHTML = `
          <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false" style="width:20px;height:20px;fill:currentColor;">
            <path d="M16 3C9.373 3 4 8.373 4 15c0 2.64.845 5.085 2.282 7.09L4 29l7.09-2.282A11.94 11.94 0 0 0 16 27c6.627 0 12-5.373 12-12S22.627 3 16 3zm0 21c-1.948 0-3.772-.572-5.29-1.554l-.378-.24-4.216 1.356 1.355-4.216-.24-.378A8.962 8.962 0 0 1 7 15c0-4.962 4.038-9 9-9s9 4.038 9 9-4.038 9-9 9zm4.356-6.707c-.237-.118-1.398-.689-1.614-.768-.216-.079-.373-.118-.53.118-.158.237-.609.768-.747.925-.138.158-.274.178-.511.06-.237-.118-.999-.368-1.902-1.173-.703-.626-1.178-1.399-1.316-1.636-.138-.237-.015-.365.104-.482.106-.105.237-.274.355-.412.118-.138.158-.237.237-.395.079-.158.04-.296-.02-.413-.06-.118-.53-1.279-.726-1.747-.192-.462-.387-.399-.53-.406-.138-.007-.296-.009-.454-.009s-.414.06-.63.296c-.216.237-.827.809-.827 1.975s.847 2.291.965 2.449c.118.158 1.667 2.546 4.043 3.568.566.245 1.008.392 1.352.502.566.18 1.084.155 1.49.094.454-.068 1.398-.571 1.594-1.122.197-.551.197-1.02.138-1.122-.06-.099-.216-.158-.454-.276z"/>
          </svg>
          TENHO INTERESSE NESSE PRODUTO
        `;

        const style = document.createElement('style');
        style.innerHTML = `
          .btn-whatsapp {
            display: inline-flex !important;
            align-items: center;
            justify-content: center;
            gap: 10px;
            width: 100%;
            min-height: 48px;
            padding: 14px 18px;
            background-color: #25D366 !important;
            color: #fff !important;
            border: none !important;
            border-radius: 8px !important;
            font-weight: 700 !important;
            cursor: pointer;
            transition: transform .06s ease, background-color .2s ease;
          }
          .btn-whatsapp:hover { background-color: #1ebe5d !important; transform: translateY(-1px); }
          .btn-whatsapp:active { transform: translateY(0); }
          .btn-whatsapp svg { width:20px; height:20px; fill:currentColor; }
        `;
        document.head.appendChild(style);
      }
    }
  );
}
